import styled from 'styled-components';
import Tabs from '../../../../../chat/components/Tabs';

const StyledTabComponent = styled(Tabs)`
  .MuiButtonBase-root {
    min-width: unset;
  }
`;

export {
  StyledTabComponent,
};
